<template>
  <transition name="el-zoom-in-top">
    <el-dialog title="工单导出明细(最新5条)" :visible.sync="show" width="65%" :modal-append-to-body='true'>
      <div style="text-align: left;">
        <el-button slot="reference" class="bottstycz" type="primary" size="mini" @click="toScExportRequest(row)">计划导出</el-button>
        <el-button slot="reference" class="el-icon-refresh" type="primary" size="mini" @click="getTabledata()">刷新</el-button>
        <el-divider></el-divider>
        <el-row>
          <el-col :span="5">
            <span style="font-weight: bold;"> 工单：</span>{{ row.orderno }}
          </el-col>
          <el-col :span="5">
            <span style="font-weight: bold;"> 批次：</span>{{ row.batchno }}
          </el-col>
          <el-col :span="5">
            <span style="font-weight: bold;"> 产品编码：</span>{{ row.product_code }}
          </el-col>
          <el-col :span="8">
            <span style="font-weight: bold;"> 产品名称：</span>{{ row.product_name }}
          </el-col>
        </el-row>

        <el-divider></el-divider>
        <el-table :data="tableData" style="width: 100%" max-height="300" highlight-current-row>
          <af-table-column fixed prop="id" label="ID" width="150">
          </af-table-column>
          <af-table-column prop="createtimeStr" label="导出时间">
          </af-table-column>
          <af-table-column prop="statusStr" label="状态"> </af-table-column>
          <el-table-column fixed="right" label="下载" min-width="250">
            <template slot-scope="props">

              <el-button type="primary" @click="exportDownload(props.row)" class="bottstycz" v-if="props.row.status == 1">
                下载</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </transition>
</template>
<script>
import {
  scExportList,
  scExportRequest,
  exportDataDownload
} from "@/api/plant";
export default {
  props: {
    search: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      reality_instorage: 0,
      row: {},
      tableData: [],
      //基础数据
      show: false,
      editshow: false,
      awardform: {}
    };
  },
  mounted () { },
  methods: {
    toScExportRequest (row) {
      this.$confirm("此操作将产生导出指令 是否继续?","提示",{
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        modal: true,
        type: "warning"
      })
        .then(() => {
          scExportRequest({
            id: row.id
          }).then(response => {
            if(response.status_code==200) {
              this.$message({
                type: "success",
                message: "发送成功!"
              });
              this.getTabledata();
            } else {
              this.$message({
                type: "woring",
                message: "发送失败!请检查字段"
              });
            }
          });
        })
        .catch(() => {
        });
    },
    exportDownload (row) {
      console.log(row);
      if(row.status==1) {
        var url=decodeURIComponent(row.oss_url);
        var link = document.createElement("a");
        link.download = url.substring(url.lastIndexOf('/')+1);
        link.href = url;
        link.click();
      }
    },
    getTabledata () {
      // 列表获取
      this.listLoading=true;
      scExportList({ id: this.row.id }).then(response => {
        this.listLoading=false;
        for(let i=0;i<response.data.length;i++) {
          response.data[i].statusStr=response.data[i].status==0? "正在导出":"已完成";
          response.data[i].createtimeStr=response.data[i].createtime.replace('T',' ');
        }
        this.tableData=response.data;
        this.show=true;
        console.log(response.data);
      });
    }
  }
};
</script>

<style>
</style>
